module.exports = __webpack_public_path__ + "6c265d8b0e3288b04da8c98eb34293bb.pdf";